import fetchRequest from '../common/fetchRequest';

export default function fetchSearchResults (url, method = 'GET', data = {}) {
    return fetchRequest(url, { method, data });
}



// WEBPACK FOOTER //
// ./src/scripts/components/search/fetchSearchResults.js